// extracted by mini-css-extract-plugin
module.exports = {"inputLabelContainer":"_textinputtwo_inputLabelContainer__97M6J","inputLabel":"_textinputtwo_inputLabel__--Avc","addonText":"_textinputtwo_addonText__2wJq8"};